<script lang="ts">
  import "@lottiefiles/lottie-player";
  import type { LottiePlayer } from "@lottiefiles/lottie-player";

  import type { Config } from "./declarations/config";
  import {
    mobileActivityIndex,
    selectedActivityIndex,
    todaysGiftOpened,
    CurrentDay,
    closedGiftSoundCounter,
  } from "./store/AppState";
  import {
    sendInteractionEvent,
    INTERACTION_TYPE_GIFT,
  } from "./utils/analytics";
  import { afterUpdate } from "svelte";
  import { playClosedGiftSound } from "./utils/AudioManager";

  // Check: https://github.com/LottieFiles/svelte-lottie-player/blob/master/src/components/utils.js
  let player: LottiePlayer;
  let giftState: number = 0;
  const today = $CurrentDay;

  export let config: Config;
  export let index: number;
  export let onLoad: () => void;

  let giftOpened = false;

  const handleClick = () => {
    if (window.isClosed && !window.isShowroom) {
      return;
    }
    player.loop = false;
    player.stop();
    if (index === 1) {
      if ($CurrentDay < $mobileActivityIndex) {
        playClosedGiftSound($closedGiftSoundCounter);
        player.play();
        $closedGiftSoundCounter = $closedGiftSoundCounter + 1;
        if ($closedGiftSoundCounter > 3) {
          $closedGiftSoundCounter = 0;
        }
        return;
      }
      $selectedActivityIndex = $mobileActivityIndex - 1;
      giftOpened = true;
      if ($selectedActivityIndex + 1 === today) {
        $todaysGiftOpened = true;
      }
    } else {
      $selectedActivityIndex = null;
    }
    player.stop();
    if (index === 0) {
      $mobileActivityIndex -= 1;
      if ($mobileActivityIndex < 1) {
        $mobileActivityIndex = 24;
      }
    }
    if (index === 2) {
      $mobileActivityIndex += 1;
      if ($mobileActivityIndex > 24) {
        $mobileActivityIndex = 1;
      }
    }
    updateGiftState();
    sendInteractionEvent(INTERACTION_TYPE_GIFT, config.order);
  };

  const handleKeydown = () => {};

  let loopCounter = 0;
  const handleLoop = () => {
    loopCounter++;
    if (loopCounter === 3) {
      player.loop = false;
    }
  };
  const handleComplete = () => {
    player.stop();
    player.seek(0);
    loopCounter = 0;

    if (!giftOpened && giftState === 1) {
      setTimeout(() => {
        player.play();
        player.loop = true;
      }, 2000);
    }
  };

  const updateGiftState = () => {
    if (today < config.order) {
      giftState = 2;
    }
    if (today === config.order) {
      if ($todaysGiftOpened) {
        giftState = 0;
      } else {
        giftState = 1;
      }
    }
    if (today > config.order) {
      giftState = 0;
    }
    if ($selectedActivityIndex && $mobileActivityIndex === config.order) {
      giftState = 3;
    }
  };

  afterUpdate(() => {
    updateGiftState();
  });
</script>

<div class="lottie-container">
  <div
    class="hitbox"
    on:pointerup={handleClick}
    on:keydown={handleKeydown}
    tabindex={index}
    role="button"
  ></div>
  {#key giftState}
    <lottie-player
      on:loop={handleLoop}
      on:complete={handleComplete}
      on:load={onLoad}
      bind:this={player}
      loop
      src={`${__PUBLIC_PATH__}darky/${config.name}/${giftState}/data.json`}
      mode="normal"
      speed="1"
      autoplay={index === 1 && today >= config.order && !giftOpened
        ? true
        : false}
      style={`width: ${index === 1 ? "30vw" : "17vw"}; margin-bottom: ${
        index === 1 ? "-1rem" : "0.5rem"
      };`}
    />
  {/key}
</div>

<style>
  .lottie-container {
    z-index: 3;
    position: relative;
    max-width: 100%;
    margin-bottom: 1rem;
  }

  .hitbox {
    height: 75%;
    bottom: 0;
    width: 100%;
    display: block;
    position: absolute;
    z-index: 4;

    cursor: default;
    pointer-events: all;
  }
</style>
